import { styled } from "@mui/material";

export const ResponsiveImage = styled("img")({
  objectFit: "scale-down",
  objectPosition: "center",
  maxWidth: "100%",
  height: "auto",
});
